export function getAllPaths(state) {
  return state.paths;
}
export function getPath(state, location, def) {
  if (def === void 0) {
    def = {};
  }

  if (state.paths !== undefined && state.paths[location]) {
    return state.paths[location];
  }

  return def;
}